import React from 'react'
import InfoTooltip from '../InfoTooltip'
import Markdown from '../Markdown.js'
const defaultClass = 'ncss-label'

export default ({ children, title, className, useBareClass, ...props }) => (
  <label {...props} className={`${useBareClass || defaultClass} ${className || ''}`} key='label'>
    {children}
    {title
      ? (<InfoTooltip key='tooltip' className='ml2-sm '>
        <div className='tooltip-markdown'>
          <Markdown source={title} />
        </div>
      </InfoTooltip>)
      : null
    }
  </label>
)



// WEBPACK FOOTER //
// ./client/src/components/ncss/Label.js